export {  NotFoundComponent } from './not-found/not-found.component';
export {  HomeComponent } from './home/home.component';
export {  ModalComponent } from './modal/modal.component';
export {  LandingComponent } from './landing/landing.component';
export {  LandingUmComponent } from './landing-um/landing-um.component';
export {  LandingEssaComponent } from './landing-essa/landing-essa.component';
export {  LandingCensComponent } from './landing-cens/landing-cens.component';
